import { footerColumns, siteName } from "@/mocks/home";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-950 text-background-200">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[320px_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                <i className="ri-book-2-fill text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{siteName}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              专注整理韩国漫画高分榜单与专题合集，收录人气神作、豆瓣高分作品与完结必看清单，帮你在海量作品里快速找到下一部想看的漫画。
            </p>
            <div className="mt-5 flex items-center gap-2.5">
              {["ri-wechat-line", "ri-weibo-line", "ri-bookmark-line", "ri-mail-line"].map((icon) => (
                <button
                  key={icon}
                  type="button"
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-50/15 text-background-200 transition-colors hover:border-accent-400 hover:text-accent-400"
                >
                  <i className={`${icon} text-lg`} />
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-4">
            {footerColumns.map((col) => (
              <div key={col.id}>
                <h4 className="font-heading text-sm font-bold text-background-50">
                  <a href="#top" className="transition-colors hover:text-accent-400">
                    {col.title}
                  </a>
                </h4>
                <ul className="mt-3.5 flex flex-col gap-2.5">
                  {col.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#top"
                        className="text-sm text-background-300 transition-colors hover:text-accent-400"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-background-50/12 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs leading-relaxed text-background-400">
            © {year} {siteName}. 本站为韩国漫画推荐与榜单整理的信息展示站点，内容为编辑整理与读者口碑汇总，仅供浏览参考。
          </p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-background-400">
            <a href="#top" className="transition-colors hover:text-accent-400">榜单说明</a>
            <a href="#top" className="transition-colors hover:text-accent-400">免责声明</a>
            <a href="#top" className="inline-flex items-center gap-1 transition-colors hover:text-accent-400">
              <i className="ri-arrow-up-line" />
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}